import { render, staticRenderFns } from "./PlayerCell.vue?vue&type=template&id=b67201f6&scoped=true&"
import script from "./PlayerCell.vue?vue&type=script&lang=js&"
export * from "./PlayerCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67201f6",
  null
  
)

export default component.exports